import { render, staticRenderFns } from "./BimElemTree.vue?vue&type=template&id=1f2e8670&scoped=true"
import script from "./BimElemTree.vue?vue&type=script&lang=js"
export * from "./BimElemTree.vue?vue&type=script&lang=js"
import style0 from "./BimElemTree.vue?vue&type=style&index=0&id=1f2e8670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e8670",
  null
  
)

export default component.exports